module.exports = __webpack_public_path__ + "img/dp-big--portfolio-05.269c71f6.jpg";